import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo.jpg";
const Navbar = () => {
  return (
    <div
      className=" sticky top-0 z-50
        py-4 bg-gray-custom  w-full h-16
        text-gray-500 font-poppins text-xs"
    >
      <div
        className="container lg:w-full h-full mx-auto left-0  
             flex justify-between items-center"
      >
        <Link to="/">
          <img
            src={logo}
            className="w-1/12 lg:w-10 lg:h-full justify-self-start select-none"
          />
        </Link>
        <div className="w-10/12 lg:w-5/12 flex justify-self-end justify-around">
          <a className="hover:text-gray-200" href="/#home">
            Home
          </a>
          <a className="hover:text-gray-200" href="/#projects">
            Projects
          </a>
          <a className="hover:text-gray-200" href="/#contact">
            Contact
          </a>
          {/* <a className="hover:text-gray-200" href="blogs">Blogs</a> */}
          <a className="hover:text-gray-200" href="/#about">
            About
          </a>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
